module.exports = __webpack_public_path__ + "img/badge.ea4b195f.png";